<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de consumo médio mensal/diário">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/almoxarifado/relatorio-consumo-medio-mensal/List'

export default {
    components: { List },
}
</script>